import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { provideGlobalGridOptions } from 'ag-grid-community'
import '@fontsource-variable/inter'
import '@fontsource-variable/jetbrains-mono'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import App from './App.tsx'
import './styles/tokens.css'
import './index.css'
import './components/ReferralPartnerPortal.css'
import { GlobalErrorBoundary } from "./helper/GlobalErrorBoundary";
import { initializeGoogleAnalytics, initializeMetaPixel } from "./helper/analytics";

provideGlobalGridOptions({ theme: 'legacy' })
initializeGoogleAnalytics()
initializeMetaPixel()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GlobalErrorBoundary>
    <App />
    </GlobalErrorBoundary>
  </StrictMode>,
)
